declare namespace $ {

	export class $mol_icon_cog extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=cog.view.tree.d.ts.map